// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Utils
import { getListChildNewLocation } from '../../../../../../common/elements/utils/elementLocationUtils';

// Selectors
import { getCurrentBoardIdFromState } from '../../../../../reducers/currentBoardId/currentBoardIdSelector';

// Components
import ContextMenuManager from '../../../../contextMenu/ContextMenuManager';

type Props = {
    quickNotesRootId: string;
    isEditable: boolean;
    gridSize: number;
    children: React.ReactNode;
};

const getLocation = (event: Event, props: Props) => {
    const { quickNotesRootId } = props;
    return getListChildNewLocation({ listId: quickNotesRootId });
};

const QuickNotesContextMenuManager = (props: Props) => {
    const currentBoardId = useSelector(getCurrentBoardIdFromState);
    return (
        <ContextMenuManager
            {...props}
            currentBoardId={currentBoardId}
            menuId="quick-notes-menu"
            className="QuickNotesContextMenuManager"
            getLocation={getLocation}
        />
    );
};

export default QuickNotesContextMenuManager;
